/* FRANTIC STUDIO · Kopfzeile passt sich der Bildschirmbreite an
   Das Logo steht mittig, das Menue links daneben. Auf Tablets und kleinen
   Laptops (oder mit laengeren Menuepunkten auf Deutsch oder Franzoesisch)
   lief das Menue unter das Logo. Dieses Skript misst nach, ob sich ein
   Menuepunkt und das Logo zu nahe kommen:
   1. Passt es, bleibt alles wie im Theme.
   2. Wird es eng, bekommen die Menuepunkte engere Abstaende (fs-nav-tight).
   3. Reicht auch das nicht, erscheint der Menue Knopf wie auf dem Handy
      (fs-nav-burger). Das Aussehen dazu steht in assets/fs-p4el.css, Teil 5.3.
   Gemessen wird bei jedem Laden, bei jeder Groessenaenderung des Fensters
   und wenn die mitlaufende Kopfzeile beim Scrollen sichtbar wird. */
(function () {
  'use strict';
  var GAP = 24; /* Mindestabstand zwischen Menuepunkt und Logo in px */
  var SEL = '.header__top--logo-center.site-header--menu-classic';

  function collides(top) {
    var logo = top.querySelector('.area--logo');
    if (!logo) return false;
    var l = logo.getBoundingClientRect();
    if (!l.width) return false;
    var items = top.querySelectorAll('.area--menu-classic nav > ul > li');
    var firstTop = null;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (!r.width) continue;
      /* Menue bricht in eine zweite Zeile um: ebenfalls zu eng */
      if (firstTop === null) firstTop = r.top;
      else if (Math.abs(r.top - firstTop) > 4) return true;
      if (r.right > l.left - GAP && r.left < l.right + GAP) return true;
    }
    return false;
  }

  function fit(top) {
    top.classList.remove('fs-nav-tight', 'fs-nav-burger');
    if (window.innerWidth < 768 || !top.offsetWidth) return;
    if (!collides(top)) return;
    top.classList.add('fs-nav-tight');
    if (!collides(top)) return;
    top.classList.remove('fs-nav-tight');
    top.classList.add('fs-nav-burger');
  }

  function fitAll() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) fit(list[i]);
  }

  /* Kurz gebuendelt per Timer (nicht per Animationsframe), damit es auch
     in Vorschaufenstern und Hintergrund Tabs zuverlaessig laeuft. */
  var timer = 0;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = 0; fitAll(); }, 60);
  }

  function start() {
    fitAll();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    window.addEventListener('orientationchange', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      var list = document.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) ro.observe(list[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* FRANTIC STUDIO · Kontakt Knopf blendet am Seitenende aus
   Der Chat Knopf (Shopify Inbox) sitzt unten links und lag am Seitenende
   genau ueber der Auswahl von Land, Waehrung und Sprache im Footer. Sobald
   der Footer ins Bild kommt, blendet der Knopf weich aus (0,3 s) und ist
   nicht mehr klickbar. Scrollt man wieder hoch, blendet er wieder ein.
   Das Aussehen dazu steht in assets/fs-p4el.css, Teil 8. Das vorhandene
   Ausblenden bei offenem Menue oder Warenkorb (snippets/chat-autohide)
   bleibt unberuehrt. */
(function () {
  'use strict';
  function start() {
    /* Der eigentliche Footer (dunkler Bereich), nicht der lange SEO Text
       davor, der ebenfalls zur Footer Gruppe gehoert. */
    var group = document.querySelectorAll('.shopify-section-group-footer-group');
    var footer = document.querySelector('.shopify-section-group-footer-group[id$="__footer"]') || group[group.length - 1];
    if (!footer || !('IntersectionObserver' in window)) return;
    var root = document.documentElement;
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      root.classList.toggle('fs-chat-away', e.isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 }).observe(footer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* FRANTIC STUDIO · Wischbare Produktreihen mit fester Rundung
   In den wischbaren Produktreihen (Startseite, Empfehlungen) wurde eine
   halb hereingeschobene Kachel am Rand gerade abgeschnitten: man sah eine
   harte Kante statt der 12 px Rundung. Jetzt bekommt das Fenster der Reihe
   selbst eine feste Rundung in Hoehe der Bildkacheln. Jede Kachel, die am
   Rand hinein oder hinaus gleitet, bleibt dadurch rund. Texte darunter
   bleiben unberuehrt. Gemessen wird nur die Lage der Bildkacheln (beim Laden
   und bei Groessenaenderung), nicht beim Wischen selbst: das Wischen bleibt
   so fluessig wie vorher. Das Aussehen steht in assets/fs-p4el.css, Teil 11. */
(function () {
  'use strict';
  var HOLDER = '.css-slider-holder';
  var TILE = '.product-item__image';
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (e) {
    for (var i = 0; i < e.length; i++) measure(e[i].target);
  }) : null;

  function measure(h) {
    var tile = h.querySelector(TILE);
    if (!tile || !tile.offsetHeight || h.scrollWidth <= h.clientWidth + 1) {
      h.classList.remove('fs-rmask');
      return;
    }
    var hr = h.getBoundingClientRect(), tr = tile.getBoundingClientRect();
    h.style.setProperty('--fs-mt', Math.max(0, Math.round(tr.top - hr.top)) + 'px');
    h.style.setProperty('--fs-mh', Math.round(tr.height) + 'px');
    h.classList.add('fs-rmask');
  }

  function scan() {
    var list = document.querySelectorAll(HOLDER);
    for (var i = 0; i < list.length; i++) {
      var h = list[i];
      if (!h.querySelector(TILE)) continue;
      measure(h);
      if (ro && seen && !seen.has(h)) { seen.add(h); ro.observe(h); }
    }
  }

  var timer = 0;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = 0; scan(); }, 80);
  }

  function start() {
    scan();
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    /* Nachgeladene Bereiche (z. B. Empfehlungen) */
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var n = m[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType === 1 && (n[j].matches(HOLDER) || n[j].querySelector(HOLDER))) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
